/*************************************************

* BAKER HUGHES COMPANY CONFIDENTIAL

* Unpublished work copyright 2025 Baker Hughes Company.  All rights reserved.

*

* This computer code is proprietary and highly confidential to Baker Hughes Company

* and/or its affiliate(s). It may not be used, disclosed, modified, transferred,

* or reproduced without prior written consent, and must be returned on demand.

**************************************************/


import { makeStyles } from '@material-ui/core/styles';
import IconButton from '@material-ui/core/IconButton';
import { useSidebarPinState } from '@backstage/core-components';
import MenuOpenIcon from '../../icons/MenuOpenIcon';
import MenuCloseIcon from '../../icons/MenuCloseIcon';

const useStyles = makeStyles(theme => ({
  menuButton: {
    marginRight: theme.spacing(2),
  },
}));

export const SidebarToggleBtn = () => {
  const { isPinned, toggleSidebarPinState } = useSidebarPinState();
  const classes = useStyles();
  return (
    <IconButton
      edge="start"
      className={classes.menuButton}
      color="inherit"
      aria-label="menu"
      onClick={() => toggleSidebarPinState()}
    >
      {isPinned ? (
        <MenuCloseIcon fontSize="large" />
      ) : (
        <MenuOpenIcon fontSize="large" />
      )}
    </IconButton>
  );
};
